const memoized = new Map();
export function memoize(fn, numArgs = 0, time = 1000) {
    return ((...args) => {
        let cache = memoized.get(fn);
        if (!cache) {
            cache = new Map();
            memoized.set(fn, cache);
        }
        const stringified = numArgs ? JSON.stringify(args.slice(0, numArgs)) : '';
        let result = cache.get(stringified);
        if (!result) {
            result = fn(...args);
            cache.set(stringified, result);
            if (result instanceof Promise) {
                result.catch(() => deleteMemoized(cache, stringified));
            }
            cache.set(stringified + '-timeout', setTimeout(() => deleteMemoized(cache, stringified), time));
        }
        return result;
    });
}
export function clearMemoized(target, fn, numArgs = 0) {
    return function (...args) {
        let cache = memoized.get(fn);
        if (cache) {
            if (!numArgs) {
                cache.forEach((timeout, key) => {
                    if (key.endsWith('-timeout'))
                        clearTimeout(timeout);
                });
                cache.clear();
            }
            else {
                const stringified = JSON.stringify(args.slice(0, numArgs));
                deleteMemoized(cache, stringified);
            }
        }
        return target.apply(this, args);
    };
}
function deleteMemoized(cache, stringified) {
    const timeout = cache.get(stringified + '-timeout');
    if (timeout) {
        clearTimeout(timeout);
        cache.delete(stringified + '-timeout');
        cache.delete(stringified);
    }
}
